// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorPage_errorContainer__gg7D9","message":"ErrorPage_message__PkbwJ","retryButton":"ErrorPage_retryButton__n6tjU"};